import { useIntl } from 'react-intl';

// MUI
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
  label: string; // id dịch intl
}

/**
 * Hiển thị phân loại vai trò:
 * Vai trò nghiệp vụ | Vai trò quản trị | Vai trò hệ thống
 */
const RoleCategory = ({ label }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1-content"
      id={`panel${label}-header`}
      sx={{ fontSize: '14px', fontWeight: 500 }}
    >
      {formatMessage({ id: label })}
    </AccordionSummary>
  );
};

export default RoleCategory;
